import _ from 'lodash';
import React from 'react';
import moment from 'moment'
import { app, api, use } from 'xadmin';
import { Icon, C } from 'xadmin-ui';
import models from './models';
import hooks from './hooks';

import Login from './pages/Login'
import Logout from './pages/Logout'
import PwdPage from './pages/PwdPage'
import Reg from './pages/Reg'
import ResetEmail from './pages/ResetEmail'
import ChangePwdNotification from './../../components/ChangePwdNotification'
import { RoleSafePage, UserSafePage, SafeSelect } from './components/SafeZone';
import freePasswordLogin from './freePasswordLogin'

import { effects } from 'redux-saga'
const { all, put, select, takeEvery } = effects

const update_models = (user) => {
  if (!user.isSuper && user.permissions) {
    const models = app.get('models')
    _.values(models).forEach(model => model.permission = {})
    const keys = _.keys(models)
    user.permissions.forEach(p => {
      const ps = p.split('.')
      const key = keys.find(k => k.toLowerCase() == ps[0].toLowerCase())
      if (key) {
        const model = models[key]
        if (ps[1]) {
          if (model.permission) {
            model.permission[ps[1]] = true
          } else {
            model.permission = { [ps[1]]: true }
          }
        }
      }
    })
  }
}

const handle_get_userinfo = function* ({ payload: user }) {
  update_models(user)
  yield put({ type: '@@oilive/PERMISSION_LOAD' })
}

const handle_user_signout = function* () {
  const locaPathname = window.location.pathname
  yield localStorage.removeItem(`user${locaPathname}`)
  yield sessionStorage.removeItem(`user${locaPathname}`)
  yield localStorage.removeItem('user')
  yield localStorage.clear()
  app.go('/logout')
}

const handle_error_message = function* () {
  yield put({ type: '@@login/ERROR_MESSAGE' })
}

const url_params = search => {
  let params = {}
  if (!search) return params
  let pairs = search.slice(1).split('&');

  pairs.forEach((pair) => {
    if (pair && pair.indexOf('=') !== -1) {
      pair = pair.split('=');
      //兼容写法
      params[pair[0]] = params[
        pair[0].toLocaleLowerCase()
      ] = decodeURIComponent(pair[1] || '');
    }
  });

  return JSON.parse(JSON.stringify(params));
}

const getParmes = (name) => {
  const url = window.location.href
  const decodeUrl = decodeURIComponent(url)
  const strs = decodeUrl.substr(decodeUrl.lastIndexOf('?'))
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = strs.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

const getUserInfo = (context, cb, token = "") => {
  const { origin, pathname } = window.location
  const { store } = context
  const option = token ? { headers: { Authorization: token } } : {}
  api({ name: 'core/auth/user' }).fetch('', option)
    .then(({ status, json }) => {
      if (status == 204) {
        //204进入向导页面
        cb(null, { ...context })
        window.location.href = `${origin}${pathname}#/systemSettingOne`
      } else {
        const userMessage = json
        const user = { ...userMessage, token: userMessage?.token || token }
        update_models(user)
        store.dispatch({ type: '@@xadmin/AUTH_SIGN_IN', payload: user })
        store.dispatch({ type: '@@xadmin/LOAD_VARIABLE' })
        cb(null, { ...context, user })
        const localValue = { ...userMessage, time: moment().unix() }
        localStorage.setItem(`user/${userMessage?.name}${pathname}`, JSON.stringify(localValue))
      }
    })
    .catch(err => {
      cb(null, { ...context })
    })
}

export default {
  name: 'iot.auth',
  models,
  hooks,
  components: {
    Login,
    SafeSelect
  },
  blocks: {
    'changePwd': () => {
      return <ChangePwdNotification />
    }
  },
  menuItems: [
    {
      title: '权限管理', parent: 'business', icon: 'User', children: [
        { title: '用户管理', url: '/app/model/User/list', icon: 'Users', permission: 'user.view' },
        { title: '角色管理', url: '/app/model/Role/list', icon: 'Role', permission: 'role.view' },
        { title: '部门管理', url: '/app/model/Department/list', icon: 'Department', permission: 'department.view' },
        { title: '安全区管理', url: '/app/model/SafeZone/list', icon: 'Department', permission: 'safezone.view' }
      ]
    },
  ],
  frontMenuItems: [
    { title: '用户管理', url: '/app/model/User/list', icon: 'User', permission: 'user.view' },
    { title: '角色管理', url: '/app/model/Role/list', icon: 'Role', permission: 'role.view' },
    { title: '部门管理', url: '/app/model/Department/list', icon: 'Department', permission: 'department.view' }
  ],
  field_render: [(SubPrev, schema) => {
    if (schema.type == 'object' && schema.name == 'User') {
      return ({ value, wrap: WrapComponent }) => {
        return (<WrapComponent>{value !== undefined ? (
          <span><Icon name="user" /> {value.username}</span>
        ) : ''}</WrapComponent>)
      }
    }
    return SubPrev
  }],
  context: (context, cb) => {
    const { store } = context
    let userName, userJson;
    const token = getParmes('token')
    const user = app?.context?.user
    const locaPathname = window.location.pathname
    if (user) userName = user?.username

    // 空间管理免密登录 
    freePasswordLogin(store, context, cb)
      .then(({ json: user }) => {
        if (user) {
          store.dispatch({ type: '@@xadmin/AUTH_SIGN_IN', payload: user })
          // 清空路由
          app.go('')
          cb(null, context)
        }
      })
      .catch(() => {
        if (userName) {
          userJson = sessionStorage.getItem(`user/${userName}${locaPathname}`) || localStorage.getItem(`user/${userName}${locaPathname}`)
        } else {
          userJson = sessionStorage.getItem(`user${locaPathname}`) || localStorage.getItem(`user${locaPathname}`)
        }

        // 从浏览器参数获取用户token
        if (token) {
          setTimeout(() => getUserInfo(context, cb, token))
        } else if (!_.isEmpty(userJson)) {
          const user = JSON.parse(userJson)
          getUserInfo(context, cb, user?.token)
        } else {
          getUserInfo(context, cb)
        }
      })
  },
  start: (app) => () => {
    const { store } = app.context
    const state = store.getState()
    if (state.user !== undefined && state.user !== null) {
      update_models(state.user)
      store.dispatch({ type: '@@oilive/PERMISSION_LOAD' })
    }
  },
  effects: (app) => function* () {
    yield takeEvery(action => action.type == '@@xadmin/AUTH_SIGN_OUT', handle_user_signout),
      yield takeEvery(action => action.type == '@@xadmin/GET_USER_INFO' && action.payload !== undefined && action.success == true, handle_get_userinfo)
    yield takeEvery(action => action.type == '@@login/GET_ERROR_MESSAGE', handle_error_message)
  },
  reducers: {
    permissionLoad: (state = false, action) => action.type == '@@oilive/PERMISSION_LOAD' ? true : state,
    errorMessage: (state = '', action) => action.type == '@@login/ERROR_MESSAGE' ? '请重新登录' : ''
  },
  mappers: {
    'auth.sign_in': {
      method: {
        onSignIn: ({ dispatch }, { location: { query } }) => (item) => {
          const { _t } = app.context
          const UserSignIn = app.get('models').UserSignIn

          return new Promise((resolve, reject) => {
            dispatch({
              model: UserSignIn(app), type: 'SAVE_ITEM', item, promise: { resolve, reject },
              message: false
            })
          }).then(user => {
            dispatch({ type: '@@xadmin/AUTH_SIGN_IN', payload: _.omit(user, 'password') })
            dispatch({ type: '@@xadmin/GET_USER_INFO', payload: _.omit(user, 'password'), success: true })
            // router.push(query && query.redirect || '/app/')
            app.go('/app/')
          }).catch(error => {
            throw new Error({ password: _t('Incorrect username or password') })
          })
        }
      }
    }
  },
  routers: {
    '/': [
      {
        path: 'login',
        component: props => <Login {...props} type="front" />
      },
      {
        path: 'logout',
        component: props => <Logout {...props} type="front" />
      },
      {
        path: 'reg',
        component: Reg
      },
      {
        path: 'pwdPage',
        component: PwdPage
      },
      {
        path: 'resetEmail',
        component: ResetEmail
      },
    ]
  },
  'role.schema': app => ({ data: role }, cb) => {
    cb(null, {
      name: 'highSetting',
      title: '高级设置',
      type: 'object',
      showInList: false,
      renderComponent: RoleSafePage
    })
  },
  'department.schema': app => ({ data: role }, cb) => {
    cb(null, {
      name: 'highSetting',
      title: '高级设置',
      type: 'object',
      showInList: false,
      renderComponent: RoleSafePage
    })
  },
  'user.schema': app => ({ data: role }, cb) => {
    cb(null, {
      name: 'highSetting',
      title: '高级设置',
      type: 'object',
      showInList: false,
      renderComponent: UserSafePage
    })
  }
}
